module.exports = __webpack_public_path__ + "img/ordMoisturizing2.b5c5cf63.jpg";